import { useRef, useEffect, useCallback } from "react"

// 3D tilt wrapper (ported from aldoo-meet)
export default function TiltWrapper({ children, className = "", maxX = 12, maxY = 16 }) {
  const containerRef = useRef(null)
  const rafRef = useRef(null)
  const cur = useRef({ x: 0, y: 0 })
  const tgt = useRef({ x: 0, y: 0 })
  const divRef = useRef(null)

  const animate = useCallback(() => {
    const lerp = 0.08
    cur.current.x += (tgt.current.x - cur.current.x) * lerp
    cur.current.y += (tgt.current.y - cur.current.y) * lerp
    if (divRef.current) {
      const { x, y } = cur.current
      divRef.current.style.transform = `rotateY(${y}deg) rotateX(${x}deg) rotateZ(${y * 0.08}deg)`
    }
    rafRef.current = requestAnimationFrame(animate)
  }, [])

  function start() { if (!rafRef.current) rafRef.current = requestAnimationFrame(animate) }
  function stop() {
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null }
    tgt.current = { x: 1, y: -4 }
    rafRef.current = requestAnimationFrame(animate)
    setTimeout(() => { if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null } }, 1200)
  }
  function move(e) {
    const r = containerRef.current?.getBoundingClientRect()
    if (!r) return
    const dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2)
    const dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2)
    tgt.current = { x: -dy * maxX, y: dx * maxY }
  }
  useEffect(() => () => { if (rafRef.current) cancelAnimationFrame(rafRef.current) }, [])

  return (
    <div ref={containerRef} className={className} style={{ perspective: "1200px" }}
      onMouseEnter={start} onMouseMove={move} onMouseLeave={stop}>
      <div ref={divRef} style={{ transform: "rotateY(-5deg) rotateX(2deg)", transformStyle: "preserve-3d", willChange: "transform" }}>
        {children}
      </div>
    </div>
  )
}